import moment from 'moment';

import { PushSchedule, PushSchedulePatch } from '../../../hooks/schedules';
import { buildScheduledAt } from '../PushScheduleFields/scheduleValues';

export interface PushScheduleEditFormValues {
  subject: string;
  message: string;
  sendMode: string;
  scheduleDate: moment.Moment | null;
  scheduleTime: moment.Moment | null;
  recurrence: string;
  recurrenceUntil: moment.Moment | null;
}

/**
 * `tsconfig.json` está com `strict: false`, então um `nextRunAt` malformado passaria
 * batido: `moment('lixo')` devolve um moment INVÁLIDO, que é truthy e cujo
 * `isSameOrBefore` é false — ou seja, escaparia das duas validações de
 * validateScheduleFields e o PATCH sairia com "Invalid date". Daí o isValid().
 */
const parseOrNull = (value?: string | null): moment.Moment | null => {
  if (!value) {
    return null;
  }
  const parsed = moment(value);
  return parsed.isValid() ? parsed : null;
};

export const toEditFormValues = (s: PushSchedule): PushScheduleEditFormValues => {
  const nextRun = parseOrNull(s.nextRunAt);
  return {
    subject: s.subject,
    message: s.message,
    sendMode: 'SCHEDULE',
    scheduleDate: nextRun,
    scheduleTime: nextRun ? moment(nextRun) : null,
    recurrence: s.recurrence,
    recurrenceUntil: parseOrNull(s.recurrenceUntil),
  };
};

/**
 * A edição altera título, mensagem, horário e recorrência. NÃO altera a audiência —
 * e agora isso é verdade por construção, não por convenção: targetType/userPks/
 * regionFilter simplesmente não fazem parte do corpo do PATCH (ver
 * hooks/schedules.ts:updatePushSchedule). O `original` entra só pelo timezone, que a
 * série já tem e a tela não edita.
 */
export const fromEditFormValues = (
  values: PushScheduleEditFormValues,
  original: PushSchedule,
): PushSchedulePatch => ({
  subject: values.subject,
  message: values.message,
  scheduledAt: buildScheduledAt(values.scheduleDate, values.scheduleTime),
  timezone: original.timezone,
  recurrence: values.recurrence as PushSchedulePatch['recurrence'],
  recurrenceUntil:
    values.recurrence === 'NONE' || !values.recurrenceUntil
      ? null
      : moment(values.recurrenceUntil).format('YYYY-MM-DD'),
});
